import {getServerTexts as getTexts, initTexts, texts} from '../../../../Localization/texts';

const entity = 'UI_ANALYSIS_PANEL';

const he = {
    // Panel titles and labels
    aiAnalysis: 'ניתוח AI',
    selectDisplayChartAnalysis: 'בחר ניתוח תרשים להצגה',
    analyzingData: 'מנתח נתונים...',
    back: 'חזרה',
    wasThisAnalysisHelpful: 'האם הניתוח הזה היה מועיל?',
    copyText: 'העתק טקסט',
    copiedToClipboard: 'הועתק ללוח',
    analysisError: 'שגיאת ניתוח',
    errorMessage: 'אירעה שגיאה בעת ניתוח נתוני התרשים.',

    // Button labels
    executive: 'ניהולי',
    comparative: 'השוואתי',
    statistical: 'סטטיסטי',

    // Analysis titles
    executiveAnalysis: 'ניתוח ניהולי',
    comparativeAnalysis: 'ניתוח השוואתי',
    statisticalAnalysis: 'ניתוח סטטיסטי',

    // Toggle panel buttons
    showAnalysis: 'הצג ניתוח',
    hideAnalysis: 'הסתר ניתוח',

    // Executive analysis content
    executiveAnalysisText1:
        'ניתוח נתוני המכירות החודשיים מפברואר 2022 עד דצמבר 2023 מגלה ביצועים עקביים בחמש קטגוריות מוצרים. ריהוט מוביל עם 2,021,964 יחידות, אחריו מצרכי מזון עם 1,998,255 יחידות, ביגוד עם 1,997,776 יחידות, צעצועים עם 1,987,245 יחידות, ואלקטרוניקה עם 1,957,098 יחידות.',
    executiveAnalysisText2:
        'נפחי המכירות החודשיים נעים בין 385,168 ל-437,919 יחידות, מה שמצביע על דפוסי מכירות יציבים עם שונות מינימלית. הנתונים מרמזים על ביקוש צרכני אחיד בקטגוריות המוצרים, עם הבדל כולל של 64,866 יחידות בין הקטגוריות בעלות הביצועים הגבוהים והנמוכים ביותר.',

    // Comparative analysis content
    comparativeAnalysisText1:
        'ניתוח השוואתי מראה כי ריהוט עלה על קטגוריות אחרות ב-1.2% משנה לשנה. מצרכי מזון שמרו על צמיחה יציבה של 0.8%, בעוד שאלקטרוניקה חוותה את התנודות המשמעותיות ביותר עם שיאים עונתיים ברבעון הרביעי.',
    comparativeAnalysisText2:
        'בהשוואת ביצועים חודשיים, נובמבר ודצמבר מציגים באופן עקבי נפחי מכירות גבוהים ב-15% בכל הקטגוריות, כאשר אלקטרוניקה רואה את העלייה הדרמטית ביותר של 27% מעל הממוצע בחודשים אלה.',

    // Statistical analysis content
    statisticalAnalysisText1:
        'ניתוח סטטיסטי מגלה סטיית תקן של 14,532 יחידות בכל קטגוריות המוצרים, המצביעה על תנודתיות נמוכה יחסית. מקדם השונות הוא 3.8%, מה שמרמז על ביצועי מכירות עקביים מאוד.',
    statisticalAnalysisText2:
        'ניתוח רגרסיה מראה מגמה חיובית קלה עם R² = 0.72, המצביע על כך ש-72% מהשונות במכירות ניתן להסביר על ידי גורמים עונתיים. ערך ה-p של 0.003 מאשר משמעות סטטיסטית בדפוסים הנצפים.',
    selectAnalysisType: 'סגנון'
};

const en = {
    // Panel titles and labels
    aiAnalysis: 'AI Chart Analysis',
    selectDisplayChartAnalysis: 'Select display chart analysis',
    analyzingData: 'Analyzing data...',
    back: 'Back',
    wasThisAnalysisHelpful: 'Was this analysis helpful?',
    copyText: 'Copy text',
    copiedToClipboard: 'Copied to clipboard',
    analysisError: 'Analysis Error',
    errorMessage: 'An error occurred while analyzing the chart data.',

    // Button labels
    executive: 'Executive',
    comparative: 'Comparative',
    statistical: 'Statistical',

    // Analysis titles
    executiveAnalysis: 'Executive Analysis',
    comparativeAnalysis: 'Comparative Analysis',
    statisticalAnalysis: 'Statistical Analysis',

    // Toggle panel buttons
    showAnalysis: 'Show Analysis',
    hideAnalysis: 'Hide Analysis',

    // Executive analysis content
    executiveAnalysisText1:
        'The analysis of monthly sales data from February 2022 to December 2023 reveals consistent performance across five product categories. Furniture leads with 2,021,964 units, followed by Groceries at 1,998,255 units, Clothing at 1,997,776 units, Toys at 1,987,245 units, and Electronics at 1,957,098 units.',
    executiveAnalysisText2:
        'Monthly sales volumes range between 385,168 and 437,919 units, indicating stable sales patterns with minimal variation. The data suggests uniform consumer demand across product categories, with a total difference of 64,866 units between the highest and lowest-performing categories.',

    // Comparative analysis content
    comparativeAnalysisText1:
        'Comparative analysis shows that Furniture has outperformed other categories by 1.2% year-over-year. Groceries maintained steady growth at 0.8%, while Electronics experienced the most significant fluctuations with seasonal peaks in Q4.',
    comparativeAnalysisText2:
        'When comparing monthly performance, November and December consistently show 15% higher sales volumes across all categories, with Electronics seeing the most dramatic increase at 27% above average during these months.',

    // Statistical analysis content
    statisticalAnalysisText1:
        'Statistical analysis reveals a standard deviation of 14,532 units across all product categories, indicating relatively low volatility. The coefficient of variation is 3.8%, suggesting highly consistent sales performance.',
    statisticalAnalysisText2:
        'Regression analysis shows a slight positive trend with R² = 0.72, indicating that 72% of sales variation can be explained by seasonal factors. The p-value of 0.003 confirms statistical significance in the observed patterns.',
    selectAnalysisType: 'Style'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'aiAnalysis',
    2: 'selectDisplayChartAnalysis',
    3: 'analyzingData',
    4: 'back',
    5: 'wasThisAnalysisHelpful',
    6: 'executive',
    7: 'comparative',
    8: 'statistical',
    9: 'executiveAnalysis',
    10: 'comparativeAnalysis',
    11: 'statisticalAnalysis',
    12: 'showAnalysis',
    13: 'hideAnalysis',
    14: 'executiveAnalysisText1',
    15: 'executiveAnalysisText2',
    16: 'comparativeAnalysisText1',
    17: 'comparativeAnalysisText2',
    18: 'statisticalAnalysisText1',
    19: 'statisticalAnalysisText2',
    20: 'analysisError',
    21: 'errorMessage',
    22: 'selectAnalysisType'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks according to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
